import React, { useState, useEffect } from "react";
import FormControl from "react-bootstrap/lib/FormControl";
import { defaultMessages } from "../../libs/i18n/default";
import { injectIntl } from "react-intl";
import { get } from "lodash";

const FormDate = ({ date, intl: { formatMessage }, formDateId, setDate, disabled }) => {
  const [formDate, setFormDate] = useState(new Date(date));
  const paddedDate = (d) => d && String(d).padStart(2, "0");
  const dateValid = formDate && formDate.toString() != "Invalid Date";
  const initialDay = dateValid ? formDate.getDate() : "";
  const initialMonth = dateValid ? paddedDate(formDate.getMonth() + 1) : "";
  const initialYear = dateValid ? formDate.getFullYear() : "";

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const monthOptions = () => [
    <option key={`${formDateId}Disabled`}></option>,
    ...months.map((m, i) => (
      <option key={`${formDateId}${m}`} value={("0" + (i + 1)).slice(-2)}>
        {formatMessage(defaultMessages[`clientComponentsDateFormMonths${m}`])}
      </option>
    )),
  ];

  const updateDate = (e) => {
    e.preventDefault();

    try {
      let day = $(`#${formDateId}_day`).val().padStart(2, "0");
      let month = $(`#${formDateId}_month`).val().padStart(2, "0");
      let year = $(`#${formDateId}_year`).val();

      let dateString = `${year}-${month}-${day}`;
      setDate(dateString);

      if (datesValid(year, month, day)) {
        let date = new Date(year, parseInt(month - 1), day);

        if (date == "Invalid Date") throw new Error();

        setFormDate(new Date(date));
      }
    } catch (err) {
      resetDate();
    }
  };

  const datesValid = (year, month, day) => validYear(year) && validDay(day) && validMonth(month);

  const resetDate = () => {
    setFormDate(null);
    setDate(null);
  };

  const validDay = (d) => new RegExp(/^\d?\d{1}$/).test(d);

  const validYear = (y) => new RegExp(/^\d{4}$/).test(y);

  const validMonth = (m) => new RegExp(/^(1[012]|0?[1-9])$/).test(m);

  return (
    <div id={formDateId}>
      <FormControl
        type="text"
        placeholder={formatMessage(defaultMessages.clientComponentsDateFormDateDay)}
        id={`${formDateId}_day`}
        defaultValue={initialDay}
        maxLength="2"
        onChange={updateDate}
        disabled={disabled}
        style={{ display: "inline", width: "33px", marginRight: "10px", padding: "5px" }}
      />

      <FormControl
        componentClass="select"
        placeholder="select"
        id={`${formDateId}_month`}
        onChange={updateDate}
        defaultValue={initialMonth}
        disabled={disabled}
        style={{ display: "inline", width: "100px", marginRight: "10px", padding: "5px" }}
      >
        {monthOptions()}
      </FormControl>

      <FormControl
        type="text"
        placeholder={formatMessage(defaultMessages.clientComponentsDateFormDateYear)}
        id={`${formDateId}_year`}
        maxLength="4"
        onChange={updateDate}
        defaultValue={initialYear}
        disabled={disabled}
        style={{ display: "inline", width: "50px", padding: "5px" }}
      />
    </div>
  );
};

export default injectIntl(FormDate);
